(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartToastInit) return;
    window.__cartToastInit = true;

    var ICONS = {
      success: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      error: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" stroke-linecap="round"/></svg>',
    };

    function getRegion() {
      var el = document.getElementById('cart-toast-region');
      if (!el) {
        el = document.createElement('div');
        el.id = 'cart-toast-region';
        el.className = 'cart-toast-region';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'false');
        document.body.appendChild(el);
      }
      return el;
    }

    document.addEventListener('cart:toast', function (event) {
      var detail = event.detail || {};
      var type = detail.type === 'error' ? 'error' : 'success';
      var message = detail.message || '';
      if (!message) return;

      var toast = document.createElement('div');
      toast.className = 'cart-toast cart-toast--' + type;

      var icon = document.createElement('span');
      icon.className = 'cart-toast__icon';
      icon.innerHTML = ICONS[type];

      var msg = document.createElement('span');
      msg.className = 'cart-toast__message';
      msg.textContent = message;

      toast.appendChild(icon);
      toast.appendChild(msg);
      getRegion().appendChild(toast);

      requestAnimationFrame(function () {
        toast.classList.add('cart-toast--visible');
      });

      var removed = false;
      function remove() {
        if (removed) return;
        removed = true;
        toast.classList.remove('cart-toast--visible');
        toast.addEventListener('transitionend', function () { toast.remove(); }, { once: true });
        setTimeout(function () { if (toast.isConnected) toast.remove(); }, 400);
      }

      var timer = setTimeout(remove, 4000);
      toast.addEventListener('click', function () { clearTimeout(timer); remove(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
